import SingleLineText, { type SingleLineTextWidgetProps } from './single-line-text';

function ParagraphTextWidget(props: SingleLineTextWidgetProps) {
  return <SingleLineText multiline {...props} />;
}

export default ParagraphTextWidget;
